












helpers = require('../../../helpers.coffee')

view_model = {
  mixins: [require('../../../mixins/notifications.coffee')]

  components:
    list: require('./list')

  data: ->
    @current_user = Session.current_user
    filters: { q: { user_id_eq: @current_user?.id } }

  methods:
    close: ->
      @$emit 'close'

    seeAllNotifications: ->
      @close()
      @$router.push '/notificacoes'

  computed:
    show_all_notifications_button: ->
      (@current_user.isManager() || @current_user.isMonitoringManager()) || @notifications_count > 0

    unread_notifications_count: ->
      @$store.getters.unreadNotificationsCount

    notifications_count: ->
      @$store.getters.notificationsCount

  created: ->
    EventsBus.$on 'NotificationDropdown::Close', @close

  beforeDestroy: ->
    EventsBus.$off 'NotificationDropdown::Close', @close
}

exports.default = helpers.vue_include(view_model)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/dropdown.vue